import React, { useState } from 'react';
import { Card, CardContent, Box, Stack, Typography, Button } from '@mui/material';
import images from 'src/config/images';
import { Modal } from 'src/components/shared';

function PaymentMethods({ cards, managePayments }) {
  const [chargeBeeUrl, setChargeBeeUrl] = useState();

  const CardItem = ({ card }) => {
    let maskedNumber = card?.masked_number || '';
    if (maskedNumber && maskedNumber !== '') {
      maskedNumber = maskedNumber
        .replace(/.(?=.{4})/g, '*')
        .match(/.{1,4}/g)
        .join(' ');
    } else {
      return null;
    }

    return (
      <Card
        variant="outlined"
        sx={{
          maxWidth: 400,
          marginTop: '12px',
          height: '54px',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Stack direction="row" p={1.6} alignItems="center">
          <Box sx={{ width: '64px' }}>
            <img src={images.billing[card.brand]} style={{ maxWidth: '40px' }} />
          </Box>
          {maskedNumber}
        </Stack>
      </Card>
    );
  };

  const onManagePayments = async () => {
    const { hosted_page } = (await managePayments()) ?? {};
    setChargeBeeUrl(hosted_page?.url);
  };

  return (
    <Card>
      <CardContent>
        <Stack justifyContent={'space-between'} direction="row">
          <Typography color="textPrimary" sx={{ fontWeight: 500 }}>
            Payment Method
          </Typography>
          <Button color="secondary" onClick={onManagePayments}>
            Manage
          </Button>
        </Stack>

        <Stack>
          {cards?.map((card) => (
            <CardItem card={card} />
          ))}
        </Stack>
        {/* <CardItem type="visa" cc="1234321465476512" /> */}
      </CardContent>
      {chargeBeeUrl && (
        <Modal
          open={true}
          onClose={() => setChargeBeeUrl()}
          sx={{
            '.MuiDialog-paper': {
              width: '400px',
              '.MuiDialogTitle-root': { position: 'absolute', width: 'calc(100% - 48px)' },
              '.MuiDialogActions-spacing': { display: 'none' },
              '.MuiDialogContent-root': {
                padding: '0',
                iframe: {
                  width: 'calc(100% - 6px)',
                  minHeight: 480,
                },
              },
            },
          }}
        >
          <iframe src={chargeBeeUrl} />
        </Modal>
      )}
    </Card>
  );
}

export default PaymentMethods;
